import React, { memo, useMemo } from 'react';

import { Box } from '@mui/material';
import PageBlock from '@sharedCR/common/PageBlock';
import DataDisplay, { DataDisplayVariant } from '@sharedCR/coreDesignSystem/DataDisplay';
import PropTypes from 'prop-types';

import { statCardStyles, statGridStyles } from '../../Construction.styles';
import { ConstructionTestIds } from '../../Construction.testIds';
import { getBudgetTotals } from '../../Construction.utils';

import { getSummaryStatsConfig } from './ConstructionSummarySection.config';

const ConstructionSummarySection = ({ budget, budgetLines, isLoading }) => {
  const totals = useMemo(() => getBudgetTotals(budgetLines), [budgetLines]);

  const stats = useMemo(() => getSummaryStatsConfig({ totals, budget }), [totals, budget]);

  return (
    <PageBlock data-testid={ConstructionTestIds.SUMMARY_SECTION} title="Construction Summary">
      <Box sx={statGridStyles}>
        {stats.map(({ id, title, value, icon }) => (
          <Box data-testid={ConstructionTestIds.SUMMARY_STAT} key={id} sx={statCardStyles}>
            <DataDisplay
              icon={icon}
              isLoading={isLoading}
              title={title}
              value={value}
              variant={DataDisplayVariant.STYLE_B}
            />
          </Box>
        ))}
      </Box>
    </PageBlock>
  );
};

ConstructionSummarySection.propTypes = {
  isLoading: PropTypes.bool,
  budget: PropTypes.object,
  budgetLines: PropTypes.array,
};

export default memo(ConstructionSummarySection);
